<style scoped>
.faucets-tab {
    display: table;
    width: 100%;
    border-collapse: collapse;
    color: #c2c7cb;
}

.faucet-row {
    display: table-row;
    border-bottom: 1px solid #526170;
}

.faucet-cell {
    display: table-cell;
    min-width: 10%;
    padding: 10px;
}

.faucets-block {
    widows: 100%;
}

.faucets .button-block {
    text-align: right;
}

.faucets .button-block a {
    margin: 0 10px;
    color: white;
}

.faucets-component {
    margin-top: 20px;
}
</style>

<template>
<div class="col-12 faucets-component">
    <div class="col-12" v-if="empty_faucets_list">
        <p class="text-center">У вас нет доступных кранов для добавления</p>
    </div>
    <div class="col-12 faucets faucets-tab" v-else>
        <div class="faucet-row" v-for="(faucet, index) in faucets" :faucet="faucet" :key="faucet.id_faucet">
            <div class="faucet-cell">
                {{faucet.name}}
            </div>
            <div class="faucet-cell">
                {{faucet.device_number}}
            </div>
            <div class="faucet-cell button-block">
                <a class="aquazor-btn-small" @click="addFaucet(faucet.device_number)">Добавить</a>
                <a class="aquazor-btn-small-red" @click="deleteRow(index, faucet)">Удалить</a>
            </div>
        </div>
    </div>
    <div class="loader" v-if="load_faucets_list">
        <loader-component />
    </div>
</div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import axios from 'axios'
import {
    store
} from '@/store'
import loader from './loader.vue'

export default {
    name: 'Faucets',
    created() {
        faucet_list_start(this)
    },
    data() {
        return {
            faucets: [],
            load_faucets_list: false,
            group_name: '',
            faucet_list_status: true,
            page_name: 'faucets-without-group',
            id_group: this.$route.params.id_group,
            empty_faucets_list: false
        }
    },
    methods: {
        deleteRow: function (index_row, faucet) {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_group', this.$route.params.id_group)
                post_data.set('id_faucet', faucet.id_faucet)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/faucets/delete_faucet',
                        data: post_data
                    })
                    .then(function (response) {
                        vue_obj.faucets.splice(index_row, 1)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        addFaucet: function (serial_number) {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_group', this.$route.params.id_group)
                post_data.set('device_number', serial_number)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/faucets/add_faucet',
                        data: post_data
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            vue_obj.$router.replace('/faucets-list/' + vue_obj.$route.params.id_group)
                        }
                    })
                    .catch(function (error) {
                        if (!!error.response.data.exception) {
                            console.log(error.response.data)
                        }
                    })
            }
        }
    },
    components: {
        'loader-component': loader,
    },
    destroyed() {
        this.faucet_list_status = false
    },
}

function faucet_list_start(vue_obj) {
    if (vue_obj.faucet_list_status) {
        get_faucets_list(vue_obj)
        setTimeout(function () {
            faucet_list_start(vue_obj)
        }, config.UPDATE_PERIOD)
    }
}

function get_faucets_list(vue_obj) {
    if (!!localStorage.token && vue_obj.faucet_list_status) {
        if (vue_obj.faucets.length == 0 && !vue_obj.empty_faucets_list) vue_obj.load_faucets_list = true
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        axios({
                method: 'POST',
                url: config.API_HOST + '/faucets/list_without_group',
                data: post_data
            })
            .then(function (response) {
                vue_obj.load_faucets_list = false
                if (vue_obj.faucets.length == 0) {
                    vue_obj.faucets = response.data.faucets
                } else {
                    response.data.faucets.forEach(element => {
                        let faucet_index = vue_obj.faucets.map(item => item.id_faucet).indexOf(element.id_faucet)
                        if (faucet_index >= 0) {
                            vue_obj.faucets[faucet_index].name = element.name
                            vue_obj.faucets[faucet_index].device_number = element.device_number
                        } else {
                            vue_obj.faucets.push(element)
                        }

                    })

                    vue_obj.faucets.forEach((view_element, index_element) => {
                        let faucet_index = response.data.faucets.map(item => item.id_faucet).indexOf(view_element.id_faucet)
                        if (faucet_index < 0) {
                            vue_obj.deleteRow(index_element)
                        }
                    })
                }
                if (vue_obj.faucets.length == 0) {
                    vue_obj.empty_faucets_list = true
                } else {
                    vue_obj.empty_faucets_list = false
                }
            })
            .catch(function (error) {

            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/faucets-without-group-list.vue